<template>
  <div class="address">
    <el-button size="mini" type="primary" class="mb20" v-if="hasPermission(866)" @click="handleAddress({})">新增地址
    </el-button>
    <el-table :data="address_list" border style="width: 100%" header-align="center">
      <el-table-column
          prop="address_name"
          label="收件人姓名"
          header-align="center"
          align="center"
          width="150"
      ></el-table-column>
      <el-table-column label="收件人电话" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ formatPhone(scope.row.address_mobile) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="地址类型" align="center" width="120">
        <template slot-scope="scope">
          <el-tag type="primary" size="small" v-show="scope.row.address_type.indexOf('1') !== -1">收货</el-tag>
          <el-tag type="success" size="small" v-show="scope.row.address_type.indexOf('2') !== -1">发票</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="收件人地址" align="center">
        <template slot-scope="scope">
          <span>{{
              scope.row.address_province
            }}{{
              scope.row.address_city == scope.row.address_province ? "" : scope.row.address_city == "市辖区" ? "" : scope.row.address_city
            }}{{ scope.row.address_country }}{{ scope.row.address_detailed }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click.native="handleAddress(scope.row)" v-if="hasPermission(867)">编辑
          </el-button>
          <el-button type="text" size="small" @click="deleteAddress(scope.row.address_id)" v-if="hasPermission(868)">
            删除
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label align="center" width="90">
        <template slot-scope="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_default == '1'">默认地址</el-tag>
          <el-button
              :disabled="!hasPermission(869)"
              type="text"
              size="small"
              class="black"
              v-else
              @click.native="updateDefaultAddress(scope.row.address_id)"
          >设为默认
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 底部分页 -->
    <div class="fr ac jc">
      <el-pagination
          :hide-on-single-page="true"
          class="mt30 mb30"
          small
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="page"
          :page-size="10"
      ></el-pagination>
    </div>
    <!-- 修改 or 添加地址 -->
    <handle-address :addressVisible.sync="visible" @success="getMemberAddress" :info="info"/>
  </div>
</template>

<script>
import HandleAddress from "@/components/HandleAddress";


export default {
  props: {},
  data() {
    return {
      visible: false,
      address_list: [],
      total: 0,
      page: 1,
      info: {}
    };
  },
  created() {
    this.getMemberAddress();
  },
  watch: {
    page(n) {
      this.getMemberAddress();
    }
  },
  methods: {
    handleAddress(row) {
      this.type = "edit";
      this.info = row;
      this.visible = true;

    },
    // 删除地址
    deleteAddress(id) {
      this.$confirm("此操作将删除该地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("addressInterfaces/v1.0/deleteAddress", {
              address_id: id
            }).then(res => {
              this.getMemberAddress();
            });
          })
          .catch(() => {
          });
    },
    // 设为默认地址
    updateDefaultAddress(id) {
      this.post("addressInterfaces/v1.0/updateDefaultAddress", {
        address_id: id
      }).then(res => {
        this.getMemberAddress();
      });
    },

    getMemberAddress() {
      this.post("addressInterfaces/v1.0/getMemberAddress", {
        page: this.page
      }).then(res => {
        let arr = res.data;
        arr.forEach(el => {
          el.address_type = el.address_type.split(",")
        })
        this.address_list = arr;
        this.total = res.total;
      });
    }
  },
  components: {
    HandleAddress
  }
};
</script>

<style lang="scss">
.address {
  .el-table {
    .el-table__header-wrapper {
      th {
        background-color: #f0f6ff;
      }
    }
  }

  .edit_address {
    .el-dialog {
      .el-dialog__header {
        background-color: #eaeaea;
        height: 40px;
        padding: 0 20px;

        .head {
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/address/index.vue